import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent as SVG } from "./SVG/us_flag.svg";

const UsFlagIcon = React.forwardRef((props, ref) => (
  <SvgIcon {...props} ref={ref} component={SVG} />
));
export default UsFlagIcon;
